import React from "react";

const BsCol = ({ className = "", children }) => (
  <div className={`w-full flex flex-wrap gap-4 ${className}`}>
    {React.Children.map(children, (child) => (
      <div className="flex-1 min-w-[200px]">{child}</div>
    ))}
  </div>
);

export default BsCol;
